import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import AlertDanger from "components/Alerts/AlertDanger"
import AlertSuccess from "components/Alerts/AlertSuccess"
import {User} from "domain-models"
import {useUser} from "hooks/StateHooks"
import Form from "mixins/form"
import {FormType} from "mixins/FormTypes"
import {Http} from "mixins/http"
import React, {createRef} from "react"
import {updateUser} from "redux/actions"
import {store} from "../../../store"
import {connect} from "react-redux"
import {GlobalState} from "../../../state"
import Trans from '../../../components/Trans'

type UpdateBudgetProps = {
  budget: number
  user: User
}

type UpdateBudgetState = {
  form: FormType
}

class UpdateBudget extends React.Component<UpdateBudgetProps, UpdateBudgetState> {
  private user = useUser()
  private form: FormType = new Form({budget: this.props.budget})
  private budgetRef = createRef<HTMLInputElement>()

  constructor(props: UpdateBudgetProps) {
    super(props)
    this.state = {
      form: this.form,
    }
  }

  update = async (event: React.MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()

    this.form.budget = this.budgetRef.current ? this.budgetRef.current.value : null

    await this.setState({
      form: this.form
    })

    await Http.put('/app-settings', {
      state: this,
      form: this.state.form
    })

    if (!this.props.user.app_settings) {
      this.props.user.app_settings = {
        auction_view: 'grid',
        budget: 0,
      }
    }

    if (!this.state.form.errors.hasErrors()) {
      this.props.user.app_settings.budget = this.state.form.budget
      store.dispatch(updateUser(this.props.user))
    }
  }

  render() {
    return (
      <div className="flex flex-col lg:flex-row flex-wrap w-full">
        <div className="flex flex-col lg:flex-row w-full">
          <div className="text-gray-600 font-semibold tracking-wide w-full lg:w-1/3 text-center lg:text-left flex flex-col">
            <div className="whitespace-no-wrap">
              <Icon icon="id-card"/>
              <span> <Trans>Budget Einstellungen</Trans></span>
            </div>
          </div>
          <form className="w-full lg:w-2/3">
            {this.state.form.successful ?
              <AlertSuccess>
                <span><Trans>Ihr Budget wurde erfolgreich gespeichert.</Trans></span>
              </AlertSuccess>
              : null}
            <div>
              <label className="block tracking-wide text-gray-600 font-semibold mb-1"><Trans>Budget</Trans></label>
              <input name="name" type="text" ref={this.budgetRef} defaultValue={this.state.form.budget} className="appearance-none block w-full bg-gray-200 text-gray-800 border border-gray-200 rounded py-2 px-3 leading-tight hover:bg-gray-100 focus:bg-gray-100 focus:border-gray-300"/>
              {
                this.state.form.errors.has('budget') ?
                  <AlertDanger>
                    <span><Trans>Das eingegebene Budget ist fehlerhaft.</Trans></span>
                  </AlertDanger>
                  : null
              }
            </div>

            <div className="mt-4 flex justify-end">
              <button className={"rounded bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 font-semibold" + (this.state.form.busy ? ' cursor-not-allowed opacity-75' : '')} onClick={this.update}>
                {this.state.form.busy ?
                  <Icon icon="spinner" spin={true}/>
                  :
                  <Icon icon="user-edit"/>
                }
                <span> <Trans>Speichern</Trans></span>
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default connect((state: GlobalState) => ({
  budget: state.user.app_settings ? state.user.app_settings.budget : 0,
  user: state.user
}))(UpdateBudget)
